/* global Date */

export default (d = 0, h = 0, m = 0, s = 0, ms = 0) => {
  const offset = ms + s * 1000 + m * 60 * 1000 + h * 60 * 60 * 1000 + d * 24 * 60 * 60 * 1000;

  return new Date(Date.now() + offset);
};
